import React, { useEffect } from "react";
//redux
import { connect } from "react-redux";
//style
import { Button } from "reactstrap";
import "./styled.css";

function Choic(props) {
  useEffect(() => {
    props.setToken("");
  }, []);
  return (
    <div className="div-choic">
      <p tabIndex={1}>
        Você gostaria de acompanhar o Digital Lovers Festival pelo nosso hotsite
        acessivel ou pela nossa plataforma de transmissão?
      </p>
      <div>
        <button
          title="Acessar a Plataforma Acessível"
          className="btn btn-primary"
          style={{ marginRight: 10 }}
          onClick={() => props.setStep("_b")}
          tabIndex={2}
        >
          Plataforma Acessível
        </button>
        <button
          title="Acessar a plataforma"
          className="btn btn-success"
          style={{ marginRight: 10 }}
          tabIndex={3}
          onClick={() => window.open("https://hall.inteegra.com.br/83778")}
        >
          Plataforma
        </button>
      </div>
    </div>
  );
}

const mapDispatchToProps = function (dispatch) {
  return {
    setToken: (data) => {
      return dispatch({ type: "SET_TOKEN", data });
    },
  };
};

export default connect(null, mapDispatchToProps)(Choic);
